import RoleAssignmentName from "./RoleAssignmentName";
import RoleAssignmentLink from "./RoleAssignmentLink";

import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import MembersGroupLink from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupLink";

import RoleName from "../../../../auth/components/role/RoleDetail/RoleName";
import RoleLink from "../../../../auth/components/role/RoleDetail/RoleLink";

import ScopeGroupName from "../../../../auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupName";
import ScopeGroupLink from "../../../../auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupLink";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const RoleAssignmentDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="RoleAssignment-detail-title"
                    >
                        { label || t`Role Assignment` }: <RoleAssignmentName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="RoleAssignment-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="RoleAssignment-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } data-testid="membersGroupId-label" sx={{ textAlign: "left" }}><Trans>Members Group</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="membersGroupId-value" sx={{ textAlign: "left" }}>{ data.membersGroupId ? (<MembersGroupLink id={ data.membersGroupId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="roleId-label" sx={{ textAlign: "left" }}><Trans>Role</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="roleId-value" sx={{ textAlign: "left" }}>{ data.roleId ? (<RoleLink id={ data.roleId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="scopeGroupId-label" sx={{ textAlign: "left" }}><Trans>Scope Group</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="scopeGroupId-value" sx={{ textAlign: "left" }}>{ data.scopeGroupId ? (<ScopeGroupLink id={ data.scopeGroupId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="createdAt-label" sx={{ textAlign: "left" }}><Trans>Created At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="createdAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.createdAt) || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default RoleAssignmentDetail;
